const mapServicesToSnakeCase = (services) =>
  (services || []).map((service) => ({
    id: service.id,
    service_multiplier: service.multiplier,
    service_name: service.name,
    service_offered_id: service.serviceId || service.id,
    service_provider_id: service.serviceProviderId,
    service_value: service.value,
  }));

export default mapServicesToSnakeCase;
